import React, { useState, useEffect } from 'react';
import styles from './NicheSelection.module.css';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000';

const NicheSelection = ({ selectedNiches, onNicheChange, isOnboarding }) => {
    const [availableNiches, setAvailableNiches] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    // Mapeamento de categorias para emojis
    const nicheIcons = {
        'Roupas Femininas': '👗',
        'Casa e Construção': '🏡',
        'Roupas Plus Size': '👚',
        'Beleza': '💄',
        'Roupas Masculinas': '👕',
        'Sapatos Femininos': '👠',
        'Sapatos Masculinos': '👞',
        'Moda Infantil': '👶',
        'Acessórios de Moda': '💍',
        'Relógios': '⌚️',
        'Celulares e Dispositivos': '📱',
        'Esportes e Lazer': '⚽️',
        'Eletrodomésticos': '🔌',
        'Brinquedos e Hobbies': '🧸',
        'Acessórios para Veículos': '🚗',
        'Saúde': '💊',
        'Áudio': '🎧',
        'Mãe e Bebê': '🤱',
        'Bolsas Femininas': '👜',
        'Bolsas Masculinas': '🎒',
        'Animais Domésticos': '🐾',
        'Papelaria': '📎',
        'Computadores e Acessórios': '💻',
        'Alimentos e Bebidas': '🍔',
        'Jogos e Consoles': '🎮',
        'Câmeras e Drones': '📷',
        'Viagens e Bagagens': '✈️',
        'Livros e Revistas': '📚',
        'Outros': '📦'
    };

    // Efeito para buscar os nichos da API, roda apenas uma vez.
    useEffect(() => {
        const fetchNiches = async () => {
            setIsLoading(true);
            try {
                const { data } = await axios.get(`${API_BASE}/api/niches`);
                setAvailableNiches(data || []);
            } catch (error) {
                console.error("Failed to fetch niches:", error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchNiches();
    }, [API_BASE]); // Dependência vazia para rodar apenas na montagem

    // Efeito para pré-selecionar todos os nichos no onboarding.
    useEffect(() => {
        if (isOnboarding && availableNiches.length > 0 && (!selectedNiches || selectedNiches.length === 0)) {
            const allNicheIds = availableNiches.map(niche => niche.id);
            onNicheChange(allNicheIds);
        }
    }, [isOnboarding, availableNiches, onNicheChange, selectedNiches]);

    const handleNicheToggle = (nicheId) => {
        const newSelected = selectedNiches.includes(nicheId)
            ? selectedNiches.filter(id => id !== nicheId)
            : [...selectedNiches, nicheId];
        onNicheChange(newSelected);
    };

    return (
        <div className={styles.nicheContainer}>
            <h3 className={styles.title}>Selecione seus nichos de interesse</h3>
            <p className={styles.subtitle}>Escolha as categorias que você mais gosta de receber.</p>
            
            {isLoading ? (
                <p>Carregando nichos...</p>
            ) : (
                <ul className={styles.nicheList}>
                    {availableNiches.map(niche => (
                        <li
                            key={niche.id}
                            className={styles.nicheItem}
                            onClick={() => handleNicheToggle(niche.id)}
                        >
                            <span className={styles.icon}>{nicheIcons[niche.name] || '🛍️'}</span>
                            <span className={styles.nicheName}>{niche.name}</span>
                            <label className={styles.switch} onClick={(e) => e.stopPropagation()}>
                                <input
                                    type="checkbox"
                                    checked={selectedNiches.includes(niche.id)}
                                    onChange={() => handleNicheToggle(niche.id)}
                                />
                                <span className={styles.slider}></span>
                            </label>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default NicheSelection;
